var _jsxFileName = "/src/main/react/src/main/app/components/images/PublishFailureTable.js";
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Grid, Typography, Button, LinearProgress, TextField, Tooltip, Fade } from '@material-ui/core';
import Util from "../../util/Util";
const styles = () => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    width: '80%'
  },
  title: {
    color: 'red',
    margin: '5px'
  }
});
class PublishFailureTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      failures: props.failures
    };
  }
  render() {
    const classes = this.props.classes;
    if (this.state.failures != null && Array.isArray(this.state.failures) && this.state.failures.length > 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.centeredContainer,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Paper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        className: classes.title,
        align: "center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 25
        }
      }, "Publish Failures:"), /*#__PURE__*/React.createElement(Table, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(TableHead, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 38,
          columnNumber: 29
        }
      }, /*#__PURE__*/React.createElement(TableRow, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39,
          columnNumber: 33
        }
      }, /*#__PURE__*/React.createElement(TableCell, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 40,
          columnNumber: 37
        }
      }, "Type"), /*#__PURE__*/React.createElement(TableCell, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41,
          columnNumber: 37
        }
      }, "Image ID"), /*#__PURE__*/React.createElement(TableCell, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42,
          columnNumber: 37
        }
      }, "Entity ID"), /*#__PURE__*/React.createElement(TableCell, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 37
        }
      }, "Failure Reason"))), /*#__PURE__*/React.createElement(TableBody, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46,
          columnNumber: 29
        }
      }, this.state.failures.map(failure => /*#__PURE__*/React.createElement(TableRow, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48,
          columnNumber: 37
        }
      }, /*#__PURE__*/React.createElement(TableCell, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49,
          columnNumber: 41
        }
      }, failure.type), /*#__PURE__*/React.createElement(TableCell, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 41
        }
      }, failure.imageId), /*#__PURE__*/React.createElement(TableCell, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 41
        }
      }, failure.entityId != null ? failure.entityId : 'N/A'), /*#__PURE__*/React.createElement(TableCell, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52,
          columnNumber: 41
        }
      }, failure.reason)))))));
    } else {
      return null;
    }
  }
}
export default withStyles(styles)(withRouter(PublishFailureTable));